export { UMB_DOCUMENT_COLLECTION_CONTEXT } from './document-collection.context-token.js';
export * from './repository/constants.js';
export * from './views/constants.js';
export const UMB_DOCUMENT_COLLECTION_ALIAS = 'Umb.Collection.Document';
